const SERVICE_REVIEWS_FILTERS_KEY = '@higa:serviceReviewsFilters'

export interface IServiceReviewsFilters {
	from?: string
	to?: string
	retails?: string[]
	attendants?: string[]
}

function isStringArray(value: unknown): value is string[] {
	return Array.isArray(value) && value.every((item) => typeof item === 'string')
}

export function getServiceReviewsFilters(): IServiceReviewsFilters {
	try {
		const stored = localStorage.getItem(SERVICE_REVIEWS_FILTERS_KEY)

		if (!stored) return {}

		const parsed = JSON.parse(stored)
		const filters: IServiceReviewsFilters = {}

		if (
			typeof parsed?.from === 'string' &&
			typeof parsed?.to === 'string' &&
			!isNaN(new Date(parsed.from).getTime()) &&
			!isNaN(new Date(parsed.to).getTime())
		) {
			filters.from = parsed.from
			filters.to = parsed.to
		}

		if (isStringArray(parsed?.retails)) filters.retails = parsed.retails
		if (isStringArray(parsed?.attendants)) {
			filters.attendants = parsed.attendants
		}

		return filters
	} catch {
		return {}
	}
}

export function setServiceReviewsFilters(
	partial: Partial<IServiceReviewsFilters>,
): void {
	try {
		localStorage.setItem(
			SERVICE_REVIEWS_FILTERS_KEY,
			JSON.stringify({ ...getServiceReviewsFilters(), ...partial }),
		)
	} catch {}
}
